
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8a8 8 0 1116 0A8 8 0 010 8zm8.567 4.437V8.085H9.77l.159-1.5h-1.36l.001-.75c0-.392.037-.602.6-.602h.75v-1.5H8.718c-1.444 0-1.952.728-1.952 1.952v.9h-.9v1.5h.9v4.352h1.801z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    